import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkItalic(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;

    return (
        <em className="italic" {...attributes}>
            {children}
        </em>
    );
}
